enum BorrowerDocTypeEnum {
    Full = 'FULL',
    Low = 'LOW',
}

export default BorrowerDocTypeEnum;
